"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyTabs = void 0;

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importDefault(require("react"));

const SskyTooltip_1 = __importDefault(require("../SskyTooltip"));

const StyledTab = (0, material_1.styled)(material_1.Tab, {
  shouldForwardProp: prop => prop !== "tabRootStyle"
})(({
  tabRootStyle
}) => ({
  [`&.${material_1.tabClasses.root}`]: Object.assign({
    minHeight: 54,
    fontSize: 14,
    minWidth: "160px"
  }, tabRootStyle)
}));
const StyledPaper = (0, material_1.styled)(material_1.Paper)({
  borderRadius: 0,
  position: "relative",
  zIndex: 2
});
const StyledTabs = (0, material_1.styled)(material_1.Tabs)({
  [`&.${material_1.tabsClasses.root}`]: {
    minHeight: 54
  }
});

const SskyTabs = props => {
  const onChange = (event, value) => {
    const selectedTabId = props.tabs[value].id;
    props.handleChange(event, selectedTabId);
  };

  const getTabsHeader = () => {
    return props.tabs.map((tab, index) => react_1.default.createElement(StyledTab, {
      className: props.tabClassName,
      key: index,
      label: tab.tooltipText ? react_1.default.createElement(SskyTooltip_1.default, {
        title: tab.tooltipText,
        placement: tab.tooltipPlacement
      }, react_1.default.createElement("span", null, tab.label)) : tab.label,
      disabled: tab.disabled,
      "data-testid": tab.dataTestId || `testId-${tab.label}`,
      style: {
        pointerEvents: "auto"
      },
      tabRootStyle: props.tabRootStyle
    }));
  };

  const tabsContent = props.tabs.find(tab => tab.id === props.selectedTabId).render();
  const value = props.tabs.findIndex(tab => tab.id === props.selectedTabId);
  return react_1.default.createElement("div", {
    className: (0, classnames_1.default)("ssky-tabs", props.className)
  }, react_1.default.createElement(StyledPaper, {
    className: "paper-root"
  }, react_1.default.createElement(StyledTabs, {
    value: value,
    onChange: onChange,
    indicatorColor: "primary",
    textColor: "primary",
    variant: props.variant
  }, getTabsHeader())), tabsContent);
};

exports.SskyTabs = SskyTabs;
SskyTabs.defaultProps = {
  tabs: []
};
exports.default = react_1.default.memo(SskyTabs);